import { DoorOpen, FileText, FolderOpen, PieChart, UserRoundSearch } from "lucide-react";

export type DashboardDataCard = {
  title: string;
  description: string;
  icon: JSX.Element;
  url?: string;
  color: string;
  role?: "buyer" | "seller" | "virtual_data_room" | "docs" | "equity";
};

export const dashboardData: DashboardDataCard[] = [
  {
    title: "Acquisition Hub",
    description: "Off-market search & seller-verified listings",
    icon: <UserRoundSearch className="w-6 h-6 text-blue-600" />,
    url: process.env.REACT_APP_BUYER_APP_URL,
    color: "text-blue-600",
    role: "buyer",
  },
  {
    title: "Seller Workspace",
    description: "Create your listing and manage buyer interest",
    icon: <DoorOpen className="w-6 h-6 text-green-600" />,
    url: process.env.REACT_APP_SELLER_APP_URL,
    color: "text-green-600",
    role: "seller",
  },
  {
    title: "Data Room (VDR)",
    description: "Set up, manage and invite users to your data rooms.",
    icon: <FolderOpen className="w-6 h-6 text-purple-600" />,
    url: process.env.REACT_APP_VDR_APP_URL,
    color: "text-purple-600",
    role: "virtual_data_room",
  },
  {
    title: "Docs",
    description: "Create, manage and collaborate on your documents.",
    icon: <FileText className="w-6 h-6 text-indigo-600" />,
    url: process.env.REACT_APP_DOCS_APP_URL,
    color: "text-indigo-600",
    role: "docs",
  },
  {
    title: "Equity",
    description: "Manage ownership, cap tables and equity distribution.",
    icon: <PieChart className="w-6 h-6 text-amber-600" />,
    url: process.env.REACT_APP_EQUITY_APP_URL,
    color: "text-amber-600",
    role: "equity",
  },
];
